import { render } from "./AposInputCheckboxes.vue?vue&type=template&id=39899900"
import script from "./AposInputCheckboxes.vue?vue&type=script&lang=js"
export * from "./AposInputCheckboxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"schema/ui/apos/components/AposInputCheckboxes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39899900"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39899900', __exports__)) {
    api.reload('39899900', __exports__)
  }
  
  module.hot.accept("./AposInputCheckboxes.vue?vue&type=template&id=39899900", () => {
    api.rerender('39899900', render)
  })

}


export default __exports__